import React from "react";

// Tarjeta de indicador (KPI) reutilizable para los dashboards del módulo.
export const KpiCard = ({ titulo, valor, icono, variante = "default" }) => {
    return (
        <div className={`kpi-card kpi-card--${variante}`}>
            {icono && <div className="kpi-card-icono">{icono}</div>}
            <div className="kpi-card-info">
                <div className="kpi-card-titulo">{titulo}</div>
                <div className="kpi-card-valor">{valor}</div>
            </div>
        </div>
    );
};
